import React, { Component } from 'react'
import firebase from 'firebase'
import {Helmet} from "react-helmet";
import TweetEmbed from 'react-tweet-embed'

const questions = [
  {
    title: 'what do you describe yourself as',
    options: [ 'title1', 'title2', 'title3', 'title4']
  },
  {
    title: 'click features you are interested in',
    options: [ 'feature1', 'feature2', 'feature3', 'feature4']
  }
]

class About extends Component {
 

  render() {

    return (
      <div>
               <Helmet   titleTemplate="auxcorde.com - %s">
           
           <title>about </title>
           <meta name="description" content="about" />
       </Helmet>
        <div id="bubbles"></div>
          <div class="form">

<div class="sign-in-form about">

      

  <h2>what is it?</h2>
    <p>
      well we don't know either 👍<br/><br/>
 but we have an idea.
 <br /> <br />
 since conception over 2 years  the idea has always been to centralize and automate as much of the digital life of artists as possible.
 <br /> <br />
We have built a bunch of stuff but only have used it privately for major label clients, indie artists, labels, festivals, and just general creatives in the industry.  
<br /> <br />
The landscape is changing rapidly so instead of building a fixed feature set we decided to build tools that can easily pivot and scale, while attacking all components of the digital life. 
<br /> <br />
Music tech is missing a big gap on the admin side — but its not the lack of admins but rather how many admins there are.
<br /> <br />
the goal is to have one central admin for everything — streaming, merch, tour, playlists, notes, private demos, album art and much more. 
<br/> <br/>You may only need a few features or all of them but we aim to add a helping hand in as many facets as possible, for as many types of people possible.
<br /> <br />
— our recluse hilarious pig emoji founder kinda describes the breadth of the tools involved, with the tweet thread below.  
<br />  <br />  
      <div class="tweets">
      
      <TweetEmbed id='1028350891529850882' options={{cards: 'hidden' , conversation:'none'
}} />
      <TweetEmbed id='1028352385884856321' options={{cards: 'hidden' , conversation:'none'
}} />
      <TweetEmbed id='1028353086237106179' options={{cards: 'hidden' , conversation:'none'
}} />
      <TweetEmbed id='1028353728359874560' options={{cards: 'hidden' , conversation:'none'
}} />

      <TweetEmbed id='1028354172788383746' options={{cards: 'hidden' , conversation:'none'
}} />

      <TweetEmbed id='1028357203500183552' options={{cards: 'hidden' , conversation:'none'
}} />


      <TweetEmbed id='1028358280656183297' options={{cards: 'hidden' , conversation:'none'
}} />



      <TweetEmbed id='1028359269668798464' options={{cards: 'hidden' , conversation:'none'
}} />



      <TweetEmbed id='1028360248246067200' options={{cards: 'hidden' , conversation:'none'
}} />



      <TweetEmbed id='1028361347229265921' options={{cards: 'hidden' , conversation:'none'
}} />

      <TweetEmbed id='1028363287308775425' options={{cards: 'hidden' , conversation:'none'
}} />

      <TweetEmbed id='1028363288382525440' options={{cards: 'hidden' , conversation:'none'
}} />
<br />
<p>this is all broad, but as we drop the different products it might start to make more sense to you guys, and us!
</p>
      </div>
      
    </p>

 
  <div class="sign-up-container">
  </div>

</div>

</div>   

 <div class="aboutBtn">
    <div><span onClick={() => this.props.history.goBack()}>back</span>
</div>
    <div class="underline-thick"></div>
  </div>
          </div>
    )
  }
}

export default About



// WEBPACK FOOTER //
// ./src/routes/About.js